/**
 * Mocked Base44 client for local browser operation.
 * Removes dependencies on external API and provides mock data logic.
 */

const getMockData = (entityName) => {
  const stored = localStorage.getItem(`mock_${entityName}`);
  return stored ? JSON.parse(stored) : [];
};

const saveMockData = (entityName, data) => {
  localStorage.setItem(`mock_${entityName}`, JSON.stringify(data));
};

export const base44 = {
  entities: {
    FinancingRequest: {
      filter: async (params) => {
        console.log("Mocked filter FinancingRequest", params);
        const data = getMockData("FinancingRequest");
        if (params.id) {
            return data.filter(d => d.id === params.id);
        }
        return data;
      },
      get: async (id) => {
        console.log("Mocked get FinancingRequest", id);
        const data = getMockData("FinancingRequest");
        return data.find(d => d.id === id);
      },
      update: async (id, data) => {
        console.log("Mocked update FinancingRequest", id, data);
        const items = getMockData("FinancingRequest");
        const index = items.findIndex(i => i.id === id);
        if (index !== -1) {
            items[index] = { ...items[index], ...data };
            saveMockData("FinancingRequest", items);
        }
        return { success: true };
      },
      create: async (data) => {
        console.log("Mocked create FinancingRequest", data);
        const items = getMockData("FinancingRequest");
        const newItem = { ...data, id: data.id || `mock-${Date.now()}` };
        items.push(newItem);
        saveMockData("FinancingRequest", items);
        return newItem;
      }
    },
    CustomerLink: {
      filter: async (params) => {
        console.log("Mocked filter CustomerLink", params);
        return getMockData("CustomerLink");
      },
      update: async (id, data) => {
        console.log("Mocked update CustomerLink", id, data);
        return { success: true };
      },
    },
  },
  functions: {
    invoke: async (functionName, data) => {
      console.log(`Mocked function invoke: ${functionName}`, data);
      
      if (functionName === 'validateCustomerLink') {
        return { 
          data: { 
            success: true, 
            link: { status: 'active', expires_at: '2025-12-31' },
            data: {} 
          } 
        };
      }
      
      if (functionName === 'generateCustomerLink') {
        return { data: { success: true, link: { token: 'mock-token' } } };
      }

      return { data: { success: true } };
    },
  },
  auth: {
    me: async () => {
      return { 
        id: "local-user-id", 
        nome: "Utente Locale", 
        cognome: "Admin",
        email: "admin@local.test",
        role: "admin" 
      };
    },
    logout: (redirectUrl) => {
      console.log("Mocked logout", redirectUrl);
    },
    redirectToLogin: (redirectUrl) => {
      console.log("Mocked redirectToLogin", redirectUrl);
    },
  },
  integrations: {
    Core: {
        UploadFile: async ({file}) => {
            console.log("Mocked UploadFile", file);
            return { file_url: URL.createObjectURL(file) };
        }
    }
  }
};
